import styled, { css } from "styled-components"
import { MAIN_FONT_COLOR } from "Styles/Global.style"

interface IStyledProps {
  primaryColor?: string
  densityWidth?: string
  density?: number
}

export const ActualityContainer = styled.div<IStyledProps>`
  // background: radial-gradient(circle at top left, #ffffff 0%, #f3f4f7 40%, #e6e8f0 100%);
  justify-content: center;
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;

  .content_wrapper {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    padding: 20px 10px 20px 20px;
    width: 100%;
    gap: 24px;

    @media (max-width: 768px) {
      padding: 16px;
    }

    .actuality_header {
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: wrap;
      display: flex;
      gap: 20px;

      &_left {
        flex-direction: column;
        display: flex;
        gap: 8px;

        .feed_title {
          letter-spacing: 0.01em;
          font-weight: 700;
          line-height: 1.2;
          font-size: 28px;
          margin: 0;
          color: ${({ primaryColor }) => primaryColor || MAIN_FONT_COLOR};
        }

        .feed_subtitle {
          font-size: 14px;
          margin: 0;
          color: #6b7280;
        }
      }

      &_right {
        min-width: 260px;
        max-width: 320px;
        display: flex;
        width: 100%;
      }

      &_right_button_wrap {
        align-items: center;
        position: relative;
        display: flex;

        .button_item {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid #ececec;
          background: #fff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: 0 20px 0 0;
          cursor: pointer;
          transition: box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease;

          i {
            font-size: 16px;
            color: #6f6f6f;
          }
          &:hover {
            background: #f7f7f7;
            border: ${({ primaryColor }) => `1px solid ${primaryColor}`};
          }
          &[aria-pressed="true"] {
            box-shadow: 0 0 0 3px rgba(209, 82, 132, 0.12);
          }
        }
      }
    }
  }
`

export const FeedSourceLink = styled.a`
  font-size: 13px;
  margin-top: 4px;
  text-decoration: none;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:after {
    content: "↗";
    font-size: 11px;
  }

  &:hover {
    text-decoration: underline;
  }
`

export const SearchWrapper = styled.div`
  width: 100%;
`

export const SearchInput = styled.input`
  width: 100%;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
  background: #fff;

  &:focus {
    border-color: #9ca3af;
    background: #ffffff;
    box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.2);
  }
`

export const MainArea = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`

export const CardsList = styled.div<IStyledProps>`
  grid-template-columns: ${({ density }) => `repeat(${density || 3}, 1fr)`};
  overflow-y: auto;
  padding: 5px 10px 16px 0;
  display: grid;
  margin: 8px 0 0 0;
  gap: 20px;
`

export const ArticleCard = styled.a<IStyledProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px 12px 16px;
  border-radius: 5px;
  text-decoration: none;
  background: #ffffff;
  max-width: 100%;
  border: 1px solid #e5e7eb;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease,
    background 0.15s ease;

  cursor: pointer;

  ${({ primaryColor }) =>
    primaryColor &&
    css`
      &:hover {
        border-color: ${primaryColor};
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
        transform: translateY(-2px);
      }
    `}
`

export const CardHeader = styled.div`
  display: flex;
`

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 600;
  color: #111827;
`

export const CardMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
`

export const MetaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:not(:last-child)::after {
    content: "•";
    margin-left: 6px;
    color: #d1d5db;
  }
`

export const CardSnippet = styled.p`
  margin: 4px 0 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #4b5563;
  max-height: 250px;
  overflow-y: auto;
  padding: 0 10px 0 0;

  img {
    max-width: 100%;
    height: auto;
  }
`

export const CategoriesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
`

export const CategoryTag = styled.span<{ $primaryColor?: string }>`
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 999px;
  background: ${({ $primaryColor }) => $primaryColor + "1a" || "#eef2ff"};
  color: ${({ $primaryColor }) => $primaryColor || "#4f46e5"};
  border: 1px solid ${({ $primaryColor }) => $primaryColor + "40" || "#e0e7ff"};
`

export const CardFooter = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  font-size: 12px;
  color: #4b5563;
`

export const FooterText = styled.span``

export const Arrow = styled.span`
  font-size: 14px;
`

/** Skeleton / Empty state */

export const SkeletonList = styled.div<IStyledProps>`
  flex-direction: column;
  display: flex;
  gap: 12px;
`

export const SkeletonCard = styled.div`
  border-radius: 16px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  margin: 0 20px 0 0;
`

export const SkeletonLine = styled.div<{ width?: string }>`
  height: 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, #f3f4f6 0%, #e5e7eb 50%, #f3f4f6 100%);
  margin-bottom: 6px;
  width: ${({ width }) => width || "100%"};
  animation: shimmer 1.4s infinite linear;

  @keyframes shimmer {
    0% {
      background-position: -40px 0;
    }
    100% {
      background-position: 40px 0;
    }
  }
`

export const EmptyState = styled.div`
  margin-top: 40px;
  text-align: center;
  color: #6b7280;
`

export const EmptyTitle = styled.h3`
  margin: 0 0 4px 0;
  font-weight: 600;
  font-size: 18px;
`

export const EmptyText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`
